import type {IDirective, ITimeoutService} from 'angular';

/**
 * @ngdoc directive
 * @name kpAutoFillSync
 * @module portaro.directives
 *
 * @description
 * Directive for workaround autofill problem e.g. in iphone chrome, which not updates ng-model value after auto fill
 *
 */
export default class AutoFillSyncDirective implements IDirective {
    public static directiveName = 'kpAutoFillSync';

    public require = 'ngModel';
    public restrict = 'A';

    /*@ngInject*/
    constructor(private $timeout: ITimeoutService) {
    }

    public link(scope, elem, attrs, ngModel) {
        const origVal = elem.val();
        this.$timeout(() => {
            const newVal = elem.val();
            if (ngModel.$pristine && origVal !== newVal) {
                ngModel.$setViewValue(newVal);
            }
        }, 500);
    }
}
